import dayjs from "dayjs";
import last_review_date from "./last-review-date.json";

/**
 * Extracts the first `last_review_date` value from the JSON data (if available).
 * It assumes the data is an array, and it maps over it to get the first date.
 *
 * @returns The first `last_review_date` value or undefined if not available
 */

const getLastReviewDate = last_review_date?.map(
  (item) => item?.last_review_date
)?.[0];

export const last_review_date_en =
  dayjs(getLastReviewDate).format("DD MMMM YYYY");

export const last_review_date_cn =
  dayjs(getLastReviewDate).format("YYYY年M月D日");
